import { render, staticRenderFns } from "./settingAccount.vue?vue&type=template&id=3513377c&scoped=true"
import script from "./settingAccount.vue?vue&type=script&lang=js"
export * from "./settingAccount.vue?vue&type=script&lang=js"
import style0 from "./settingAccount.vue?vue&type=style&index=0&id=3513377c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3513377c",
  null
  
)

export default component.exports